<script setup>
import {useUsersStore} from "@/stores"
import CmsText from '@/@core/components/CmsText.vue'

const emit = defineEmits([
  'confirm',
  'cancel'
])
const usersStore = useUsersStore()
let isShowingPreferredRequestInfoDialog = null;
({isShowingPreferredRequestInfoDialog} = storeToRefs(usersStore))



const onClose = () => {
  emit('close', true)
  isShowingPreferredRequestInfoDialog.value = false

  //if dontShowAgain is checked, save to local storage
  if(dontShowAgain.value){
    localStorage.setItem('dontShowPreferredRequestInfo2', true)
  }
}
const tab = ref('how-rm-works')
const dontShowAgain = ref(false)
</script>

<template>
  <!-- 👉 Confirm Dialog -->
  <!--  :width="$vuetify.display.mdAndDown ? '100%' : 650 " -->
  <!--  fullscreen="" -->
  <VDialog
    max-width="450"
    :model-value="isShowingPreferredRequestInfoDialog"
  >
    <VCard class="px-5 py-6 pb-6 info-card">
      <VCardTitle
        class="text-center text-sm pb-0"
        style="white-space: normal; color: rgba(0, 0, 0, 0.6);"
      >
        <CmsText
          k="members.masthead"
          tag="div"
        />
      </VCardTitle>
      <div class="text-center text-xs">
        <!--
          (restaurants' private inventory)<br>
          (i.e. N/A on OpenTable, Resy etc.)<br> 
        -->
      </div>
      <div
        style="display: flex;"
        class="justify-center mt-4"
      >
        <VTabs
          v-model="tab"
          class="tab-height full-width-tabs"
          grow
        >
          <VTab
            value="how-rm-works"
            class="tab-height text-xs"
          >
            <CmsText
              k="members.tabs.howRmWorksTitle"
              tag="span"
            />
          </VTab>
          <VTab
            value="faqs"
            class="tab-height text-xs"
          >
            FAQs
          </VTab>
        </VTabs>
      </div>
      <VDivider />
      <VWindow
        v-model="tab"
        class="scrollable-window"
      >
        <VWindowItem
          class="pt-4 text-xs scrollable-content"
          value="how-rm-works"
        >
          <div class="content-wrapper tab-content-width">
            <CmsText
              k="members.tabs.howRmWorks"
              tag="div"
              class="section-subtitle text-left mt-2 how-rm-works-content"
              style="line-height: 1.4em;"
            />
          </div>
        </VWindowItem>
        <VWindowItem
          class="pt-4 text-xs scrollable-content"
          value="faqs"
        >
          <div class="content-wrapper tab-content-width">
            <CmsText
              k="members.tabs.faqs"
              tag="div"
              class="section-subtitle text-left mt-2 faqs-content"
              style="line-height: 1.4em;"
            />
          </div>
        </VWindowItem>
      </VWindow>


      <!--      <VCardActions class="align-center justify-center gap-2 mt-4"> -->
      <!--        <v-checkbox -->
      <!--          v-model="dontShowAgain" -->
      <!--          :label="`Don't show again`" -->
      <!--          persistent-hint -->
      <!--        ></v-checkbox> -->

      <!--      </VCardActions> -->
      <!--      <VCardActions class="align-center justify-center gap-2"> -->
      <!--        <VBtn -->
      <!--          variant="elevated" -->
      <!--          @click="onClose" -->
      <!--        >Got it!</VBtn> -->

      <!--      </VCardActions> -->
    </VCard>
    <VBtn
      icon="$close"
      size="large"
      variant="text"
      color="secondary"
      class="dialog-close-btn"
      @click="onClose"
    >
      <VIcon>mdi-close</VIcon>
    </VBtn>
  </VDialog>
</template>

<style scoped>
.dialog-close-btn {
  position: fixed;
  right: 6px;
  top: 6px;
}

.full-width-tabs {
  width: 100%;
}

.full-width-tabs .v-tab {
  flex: 1;
  max-width: 50%;
  justify-content: center;
}

/* Bound the card to the dialog and lay it out as a column so the header keeps
   its natural height and the scroll region fills whatever space remains. */
.info-card {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
}

/* Flex chain from the card down to the scrolling leaf. Every level is a flex
   column with min-height:0 so the height resolves without percentages (which
   don't resolve through Vuetify's flex-sized window wrapper) and only the leaf
   scrolls instead of overflowing the dialog. */
.scrollable-window {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.scrollable-window :deep(.v-window__container) {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.scrollable-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  /* breathing room so the last line isn't flush against the bottom edge */
  padding-bottom: 16px;
}

.how-rm-works-content {
  font-family: inherit !important;
  color: rgba(0, 0, 0, 0.6) !important;
}

.how-rm-works-content :deep(p) {
  margin: 0 !important;
  font-family: inherit !important;
  font-size: 0.75rem !important;
  color: rgba(0, 0, 0, 0.6) !important;
}

.how-rm-works-content :deep(b) {
  font-family: inherit !important;
  color: rgba(0, 0, 0, 0.6) !important;
}

.how-rm-works-content :deep(a) {
  color: rgb(var(--v-theme-primary));
}

.how-rm-works-content :deep(p.section-title) {
  margin-top: 1rem !important;
}

.how-rm-works-content :deep(p.section-title:first-child) {
  margin-top: 0 !important;
}

.faqs-content {
  font-family: inherit !important;
  color: rgba(0, 0, 0, 0.6) !important;
}

.faqs-content :deep(p) {
  margin: 0 !important;
  font-family: inherit !important;
  font-size: 0.75rem !important;
  color: rgba(0, 0, 0, 0.6) !important;
}

.faqs-content :deep(b) {
  font-family: inherit !important;
  color: rgba(0, 0, 0, 0.6) !important;
}

.faqs-content :deep(a) {
  color: rgb(var(--v-theme-primary));
}

.faqs-content :deep(p.faq-title) {
  margin-top: 1rem !important;
}

.faqs-content :deep(p.faq-title:first-child) {
  margin-top: 0 !important;
}

.faqs-content :deep(p.faq-subsection) {
  margin-top: 0.5rem !important;
}
</style>
